import { Component, OnInit } from '@angular/core';
import { CompaniesListService } from 'app/company-list-page/services/companies-list.service';
import { HttpService } from 'app/shared/services/http.service';
import * as emiGlobals from 'app/globals';
import { ICompaniesList } from 'app/company-list-page/interfaces/icompanies-list';
import { ProductOffer } from "app/calculators/Product";
import { Router } from '@angular/router';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.css']
})
export class CompanyDetailsComponent implements OnInit {

  filteredItems;
  companieslist;
  companyNameSearch: any
  companyListForFilter: any;
  companiesList: ICompaniesList[];
  productOffer: ProductOffer = new ProductOffer();
  

  bankList: any;
  constructor(public httpService: HttpService, public router: Router) {

   }

  ngOnInit() {
    this.getAllBankList();

  }
  // getAllCompaniesList() {
  //   this.httpService.getAll(emiGlobals.companyList).subscribe(result => {
  //     this.filteredItems = result;
  //     this.companiesList = this.filteredItems;
  //   });

  // }
  getAllCompaniesList(bank) {
    this.httpService.getAll(emiGlobals.companyListByBankId + '/' +  bank).subscribe(result => {
      this.filteredItems = result;
      this.companiesList = this.filteredItems;
    });

  }

  filterItem(value) {
    this.httpService.getAll(emiGlobals.companyListByBankId + '/' +  this.productOffer.bankId + '?value=' + value).subscribe(result => {
      if (value) {
        this.filteredItems = result;
        console.log('-- this.filteredItems',  this.filteredItems);
        this.companiesList = this.filteredItems;
        console.log('-- this.companiesList',  this.companiesList);
      } else {
        this.filteredItems = [];
      }
    });

    // this.getAllCompaniesList(this.productOffer.bankId); 
    // this.showform=true;
    // this.success_message = false;
   
    // if (!value) this.assignCopy(); //when nothing has typed
    // this.filteredItems = Object.assign([], this.companiesList).filter(
    //   item => item.company_name.toLowerCase().indexOf(value.toLowerCase()) > -1
    // )
  }
  assignCopy() {
    this.filteredItems = Object.assign([], this.companiesList);
  }

  getAllBanks() {
    this.httpService.getAll(emiGlobals.getBankListUrl).subscribe(result => {
      console.log('---res', result);
    })
  }

  // To get All Bank List

  getAllBankList() {
    this.httpService.getAll(emiGlobals.getBankListUrl).subscribe(result => {
     this.bankList = result.banks;
    });
  }
  onChangeOfOption(bank) {
    this.productOffer.bankId = bank;
  }
  onClickOfViewMore(companyId) {
    // this.router.navigate(['/users'], { queryParams: { filter: 'new'}, queryParamsHandling: 'merge' });
  this.router.navigate(['group-details/' + companyId], { queryParams: { companygrp: companyId,bankId: this.productOffer.bankId}, queryParamsHandling: 'merge' });
  // this.router.navigate(['group-details/' + companyId + '/' + '?bankId=' + this.productOffer.bankId]);
  }
}


// WEBPACK FOOTER //
// ./src/app/company-details/company-details.component.ts